module.exports = __webpack_public_path__ + "bbeededb54e7e24994be9299ce8b71b4.svg";